import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import styles from './index.module.css';
import { Box } from "@chakra-ui/react";
import {
    ProgressCircleRing,
    ProgressCircleRoot,
} from "../ui/progress-circle"

const propTypes = {
    isEnableLoader: PropTypes.bool,
    isUserLoggedIn: PropTypes.bool,
};

const defaultProps = {
    isEnableLoader: false,
    isUserLoggedIn: false
};

const Loader = props => {
    return (
        props.isUserLoggedIn && props.isEnableLoader && (<Box className={styles.loader}>
            <ProgressCircleRoot value={null} size="lg">
                <ProgressCircleRing cap="round" css={{ "--thickness": "4px" }} />
            </ProgressCircleRoot>
        </Box>)
    );
}

Loader.propTypes = propTypes

Loader.defaultProps = defaultProps;

const mapStateToProps = state => ({
    isEnableLoader: state.loaderReducer.isEnableLoader,
    isUserLoggedIn: state.loginReducer.isloggedIn
});

const mapDispatchToProps = dispatch => ({
});

export default connect(mapStateToProps, mapDispatchToProps)((Loader));